/* OUTLENA theme JS — cart drawer (AJAX), quick add, parallax, tilt, 3D ring, popup, reveal */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  document.documentElement.classList.add('js');

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '€' + v;
  }

  /* ---------- Toast ---------- */
  var toastT;
  window.oToast = function (msg) {
    clearTimeout(toastT);
    var t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.style.display = 'block';
    toastT = setTimeout(function () { t.style.display = 'none'; }, 3000);
  };

  /* ---------- Cart drawer ---------- */
  function openCart() { document.body.classList.remove('nav-open'); document.body.classList.add('cart-open'); }
  function closeCart() { document.body.classList.remove('cart-open'); }
  function toggleNav() { document.body.classList.toggle('nav-open'); }
  function closeNav() { document.body.classList.remove('nav-open'); }

  function updateUpsell(cart, upsell) {
    if (!upsell) return;
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });
    var cards = upsell.querySelectorAll('[data-up-pid]');
    var shown = 0;
    cards.forEach(function (c) {
      var pid = parseInt(c.getAttribute('data-up-pid'), 10);
      if (inCart[pid] || shown >= 2) { c.style.display = 'none'; }
      else { c.style.display = 'flex'; shown++; }
    });
    upsell.style.display = shown > 0 ? 'block' : 'none';
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var lines = $('[data-cart-lines]');
    var emptyEl = $('[data-cart-empty]');
    var footEl = $('[data-cart-foot]');
    if (!lines) return;
    var upsell = $('[data-cart-upsell]');
    if (cart.item_count === 0) {
      lines.style.display = 'none';
      if (footEl) footEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'flex';
      if (upsell) upsell.style.display = 'none';
    } else {
      lines.style.display = 'block';
      if (footEl) footEl.style.display = 'block';
      if (emptyEl) emptyEl.style.display = 'none';
      updateUpsell(cart, upsell);
      lines.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img class="od__thumb" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') + '" alt="">' : '<div class="od__thumb"></div>';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="od__var">SIZE ' + it.variant_title.toUpperCase() + '</div>' : '';
        return '<div class="od__line">' + img +
          '<div class="od__mid"><div class="od__name">' + it.product_title + '</div>' + variant +
          '<div class="od__qty"><button data-qty="-1" data-key="' + it.key + '">−</button><span>' + it.quantity + '</span><button data-qty="1" data-key="' + it.key + '">+</button></div></div>' +
          '<div class="od__right"><div class="od__lineprice">' + money(it.final_line_price) + '</div><button class="od__rm" data-rm="' + it.key + '" title="Remove">×</button></div></div>';
      }).join('');
    }
    var sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = money(cart.items_subtotal_price);
    var co = $('[data-checkout-total]'); if (co) co.textContent = money(cart.items_subtotal_price);
    var thr = parseInt(document.body.getAttribute('data-freeship') || '0', 10);
    var fill = $('[data-ship-fill]'); var msg = $('[data-ship-msg]');
    if (thr > 0 && fill && msg) {
      var pct = Math.min(100, (cart.items_subtotal_price / thr) * 100);
      fill.style.width = pct + '%';
      msg.textContent = cart.items_subtotal_price >= thr ? 'Free shipping unlocked ✓' : ('You’re ' + money(thr - cart.items_subtotal_price) + ' away from free shipping');
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () { return fetchCart(); }).then(function () { openCart(); })
      .catch(function (e) { window.oToast((e && e.description) || 'Could not add to cart'); });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var openBtn = t.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }
    if (t.closest('[data-nav-toggle]')) { toggleNav(); return; }
    if (t.closest('.hdr__link')) { closeNav(); }
    var qtyBtn = t.closest('[data-qty]');
    if (qtyBtn) {
      var line = qtyBtn.closest('.od__line');
      var cur = parseInt(line.querySelector('.od__qty span').textContent, 10);
      changeQty(qtyBtn.getAttribute('data-key'), Math.max(0, cur + parseInt(qtyBtn.getAttribute('data-qty'), 10)));
      return;
    }
    var rm = t.closest('[data-rm]');
    if (rm) { changeQty(rm.getAttribute('data-rm'), 0); return; }
    var quick = t.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault(); e.stopPropagation();
      var variants = [];
      try { variants = JSON.parse(quick.getAttribute('data-variants') || '[]'); } catch (err) {}
      var avail = variants.filter(function (v) { return v.available; });
      if (!avail.length) { window.oToast('Sold out'); return; }
      var pick = avail.find(function (v) { return /(^|\s|\/)M($|\s|\/)/i.test(v.title); }) || avail[0];
      addToCart(pick.id, 1);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); hidePopup(); }
  });

  /* PDP add-to-cart form */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-atc]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var id = fd.get('id');
    if (!id) { window.oToast('Pick a size first'); return; }
    addToCart(parseInt(id, 10), parseInt(fd.get('quantity') || '1', 10));
  });

  /* ---------- Newsletter popup ---------- */
  function hidePopup() {
    var p = $('[data-popup]');
    if (p) p.style.display = 'none';
  }
  function initPopup() {
    var p = $('[data-popup]');
    if (!p) return;
    var KEY = 'outlena-nl-seen';
    try { if (localStorage.getItem(KEY)) return; } catch (e) {}
    var delay = parseInt(p.getAttribute('data-delay') || '7', 10) * 1000;
    setTimeout(function () {
      if (document.body.classList.contains('cart-open')) return;
      p.style.display = 'block';
    }, delay);
    $$('[data-popup-close]', p).forEach(function (b) {
      b.addEventListener('click', function () {
        p.style.display = 'none';
        try { localStorage.setItem(KEY, '1'); } catch (e) {}
      });
    });
    var form = p.querySelector('form');
    if (form) form.addEventListener('submit', function () {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    });
  }

  /* ---------- Scroll FX ---------- */
  var raf = 0;
  function onScroll() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      var y = window.scrollY;
      $$('[data-depth]').forEach(function (el) {
        el.style.marginTop = (-y * (parseFloat(el.getAttribute('data-depth')) || 0)).toFixed(1) + 'px';
      });
      $$('[data-hero-3d]').forEach(function (hero) {
        var sign = parseFloat(hero.getAttribute('data-hero-3d')) || 1;
        var r = hero.getBoundingClientRect();
        var prog = Math.max(0, Math.min(1, 1 - r.top / window.innerHeight));
        hero.style.transform = 'perspective(1200px) rotateY(' + (sign * (4 + prog * 14)).toFixed(2) + 'deg) rotateX(' + (prog * 5).toFixed(2) + 'deg)';
      });
      var hdr = $('.hdr');
      if (hdr) hdr.classList.toggle('is-scrolled', y > 12);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Tilt ---------- */
  document.addEventListener('mousemove', function (e) {
    var el = e.target.closest('.tilt');
    if (!el) return;
    var r = el.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width - 0.5;
    var y = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = 'perspective(900px) rotateX(' + (-y * 9).toFixed(2) + 'deg) rotateY(' + (x * 11).toFixed(2) + 'deg) translateY(-4px)';
  });
  document.addEventListener('mouseout', function (e) {
    var el = e.target.closest('.tilt');
    if (el && !el.contains(e.relatedTarget)) el.style.transform = '';
  });

  /* ---------- 3D ring ---------- */
  function initRing(stage) {
    if (stage.dataset.ringInit) return;
    stage.dataset.ringInit = '1';
    var ring = stage.querySelector('.ring');
    if (!ring) return;
    var angle = -12, drag = null, moved = 0;
    function loop() {
      if (!drag) angle += 0.05;
      var rs = Math.min(1, Math.max(0.55, window.innerWidth / 640));
      ring.style.transform = 'scale(' + rs.toFixed(3) + ') rotateY(' + angle.toFixed(2) + 'deg)';
      requestAnimationFrame(loop);
    }
    loop();
    stage.addEventListener('pointerdown', function (e) {
      drag = { x: e.clientX, a: angle }; moved = 0;
      stage.style.cursor = 'grabbing';
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      moved = Math.max(moved, Math.abs(dx));
      angle = drag.a + dx * 0.35;
    });
    function end() { drag = null; stage.style.cursor = 'grab'; }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('click', function (e) {
      if (moved > 8) { e.stopPropagation(); e.preventDefault(); }
    }, true);
  }

  /* ---------- Reveal ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: 0.1 }) : null;

  function initAll() {
    $$('[data-ring-stage]').forEach(initRing);
    $$('[data-hero-video], .hero__media video').forEach(function (v) {
      if (v.dataset.vInit) return;
      v.dataset.vInit = '1';
      v.muted = true; v.loop = true; v.setAttribute('playsinline', '');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
    if (io) $$('[data-reveal]').forEach(function (el) {
      if (el.dataset.revealDone) return;
      el.dataset.revealDone = '1';
      if (el.getBoundingClientRect().top > window.innerHeight * 0.92) {
        el.classList.add('pre');
        io.observe(el);
      }
    });
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
    initPopup();
    fetchCart();
  });
  document.addEventListener('shopify:section:load', initAll);
})();
